import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { Palette } from 'lucide-react';
import { Audience } from '@/store/videoFeatures';
import { ColorEditorPopover } from '@/components/feature-configs/autoplay/ColorEditorPopover';
import { cn } from '@/lib/utils';

interface StyleTabProps {
  audience: Audience;
  updateAudience: (key: string, value: any) => void;
  isDisabled: boolean;
}

export const StyleTab: React.FC<StyleTabProps> = ({
  audience,
  updateAudience,
  isDisabled
}) => {
  useLanguage();
  const handleStyleChange = (key: string, value: any) => {
    updateAudience('style', {
      ...(audience.style || {}),
      [key]: value
    });
  };

  return (
    <div className="space-y-4">
      {/* Card: Aparência */}
      <div className={cn('bg-white border border-[#E4E7EC] rounded-[14px] p-4 transition-all', isDisabled && 'opacity-50 pointer-events-none blur-[1px]')}>
        <div className="flex items-center gap-3 mb-5">
          <div className="w-9 h-9 rounded-[10px] bg-[#EEF4FF] flex items-center justify-center flex-shrink-0">
            <Palette className="w-[18px] h-[18px] text-[#1D4FFF]" strokeWidth={2} />
          </div>
          <span className="text-[14px] font-semibold text-[#1A1A1A]">
            {translateInterfaceText("Aparência")}</span>
        </div>

        {/* Grid 2 colunas para cores */}
        <div className="grid grid-cols-2 gap-6">
          {/* Fundo */}
          <div className="flex flex-col items-center gap-2">
            <span className="text-[11px] text-muted-foreground font-medium">{translateInterfaceText("Fundo")}</span>
            <ColorEditorPopover
              colorName={translateInterfaceText("Fundo")}
              currentColor={audience.style?.backgroundColor || 'rgba(0, 0, 0, 1)'}
              onSave={(newColor) => handleStyleChange('backgroundColor', newColor)}
            >
              <button
                type="button"
                className="w-11 h-11 rounded-full border-2 border-[#E4E7EC] hover:border-[#1D4FFF]/30 hover:scale-105 transition-all cursor-pointer shadow-sm"
                style={{ backgroundColor: audience.style?.backgroundColor || '#000000' }}
              />
            </ColorEditorPopover>
          </div>

          {/* Texto */}
          <div className="flex flex-col items-center gap-2">
            <span className="text-[11px] text-muted-foreground font-medium">{translateInterfaceText("Texto")}</span>
            <ColorEditorPopover
              colorName={translateInterfaceText("Texto")}
              currentColor={audience.style?.textColor || 'rgba(255, 255, 255, 1)'}
              onSave={(newColor) => handleStyleChange('textColor', newColor)}
            >
              <button
                type="button"
                className="w-11 h-11 rounded-full border-2 border-[#E4E7EC] hover:border-[#1D4FFF]/30 hover:scale-105 transition-all cursor-pointer shadow-sm"
                style={{ backgroundColor: audience.style?.textColor || '#ffffff' }}
              />
            </ColorEditorPopover>
          </div>
        </div>
      </div>
    </div>
  );
};
